export enum PaymentFrequency {
  Unspecified = '',
  Annually = 'Annually',
  Monthly = 'Monthly',
}

export enum PaymentMethod {
  Unspecified = '',
  DirectDebit = 'Direct Debit',
  CreditCard = 'Credit Card',
  BPAY = 'BPAY',
}

export enum CardTypes {
  Unspecified = '',
  Visa = 'Visa',
  Mastercard = 'Mastercard',
}

export type BsbDetails = {
  bsb: string;
  bankName: string;
  branchAddress: string;
  branchPostcode: string;
};

export type DirectDebitDetails = {
  accountName: string;
  accountNumber: string;
  bsbDetails: BsbDetails;
};

export type CreditCardDetails = {
  cardNumber: string;
  cardName: string;
  cardExpiry: string;
  cardCvv: string;
  cardType: CardTypes;
};

export interface PaymentDetailsData {
  paymentFrequency: PaymentFrequency;
  paymentDate: string;
  paymentMethod: PaymentMethod;
  paymentCardType: CardTypes;
}

export enum PaymentWhen {
  Now = 'now',
  DueDate = 'due-date',
}
